<script>
  import { onDestroy } from 'svelte';
  import { sortBy } from 'lodash-es';
  import { page } from '$app/stores';

  import Text from '@components/Text.svelte';
  import MobileOptionsModal from '@components/MobileOptionsModal.svelte';
  import Notification from '@utils/notification';
  import ScrollSpy from '@utils/scrollspy';
  import ComponentEvents from '@utils/component-events';
  import { getGroupStore } from '@stores/group';
  let sectionsStore = getGroupStore('sectionsStore');
  let groupStore = getGroupStore('groupStore');
  let recsStore = getGroupStore('recsStore');
  import CustomScroll from '@utils/custom-scroll';

  import SectionAjax from '@ajax/section';
  import RecObjectAjax from '@ajax/rec_object';

  import RecObject from '@app-components/RecObject.svelte';
  import RemoveSectionModal from '@app-components/modal/RemoveSectionModal.svelte';
  import Sortable from 'sortablejs';
  const AutoScroll = Sortable.AutoScroll;
  import { goto } from '$app/navigation';
  import { inview } from 'svelte-inview';

  try {
    Sortable.mount(new AutoScroll());
  } catch {}

  export let mobile = false;
  export let id;
  export let editable = true;
  export let scrollPastRecId = null;
  export let showAddComment = false;

  import jQuery from 'jquery';

  let group = groupStore;
  let section = sectionsStore.find(id);
  let recs = [];
  let recObjectIds = [];
  let showRemoveModal = false;
  let showSectionsMenu = false;

  let sortByOrder = function (instance, orderIds) {
    return sortBy(instance, (x) => {
      var idx = orderIds.indexOf(x);
      if (idx == -1) {
        idx = 9999;
      }
      return idx;
    });
  };

  $: userCanEdit = group && group.permissions && group.permissions.edit;
  $: isEditable = userCanEdit && editable;

  let modalOptions = [
    {
      label: 'Move section',
      image: '<img src="/images/profile/organize.svg" />',
      fn: async () => {
        goto(`${group.path_with_user_id}/edit`);
      },
    },
    {
      label: '<span style="color: #FF5567">Delete</span>',
      image: '<img src="/images/profile/trash.svg" />',
      fn: async () => {
        showRemoveModal = true;
      },
    },
  ];
  if (section != null) {
    modalOptions = [
      modalOptions[0],
      {
        label: 'Share section',
        image: '<img src="/images/options-menu/share.svg" />',
        fn: async () => {
          CustomScroll.copySectionLink($page, section.id);
        },
      },
      modalOptions[1],
    ];
  }

  let computeRecObjectIdsFromRecs = function (recs) {
    let tempIds = [...new Set(recs.map((r) => r.rec_object_id))]; // unique ids
    let sortOrder = [...(section ? section.sort_order : []), ...group.rec_objects_sort_order].map((x) => parseInt(x));
    tempIds = sortByOrder(tempIds, sortOrder);
    recObjectIds = tempIds;
  };

  let unsubSection = section ? section.subscribe((x) => (section = x)) : null;
  let unsubGroup = groupStore.subscribe((x) => (group = x));

  let unsubRecs = recsStore.subscribe((x) => {
    if (section) {
      recs = x.where({ section_id: section.id });
    } else {
      recs = x;
    }

    computeRecObjectIdsFromRecs(recs);
  });

  let removeSection = function () {
    showRemoveModal = true;
  };

  let updateSection = async function (data) {
    try {
      section.set(await SectionAjax.update(group, section, data));
      sectionsStore.runCallbacks();
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
        section = section;
      }
    }
  };

  let sortOrderWithSectionsFromPage = function () {
    let sectionData = [];

    jQuery('[data-section-id]').each(function () {
      let recObjectIds = [];
      let recIds = [];
      let id = jQuery(this).data('section-id');

      jQuery(this)
        .find('[data-rec-object-id]')
        .each(function () {
          var recObjectId = jQuery(this).data('rec-object-id');
          recObjectIds.push(recObjectId);
        });

      jQuery(this)
        .find('[data-rec-id]')
        .each(function () {
          var recId = jQuery(this).data('rec-id');
          recIds.push(recId);
        });

      sectionData.push({
        id: id,
        rec_object_ids: recObjectIds,
        rec_ids: recIds,
      });
    });

    return sectionData;
  };

  let updateSortOrder = function (evt) {
    let sortOrder = sortOrderWithSectionsFromPage();
    RecObjectAjax.updateSortOrder(group, sortOrder);

    let newSectionId = jQuery(evt.item).closest('[data-section-id]').data('section-id');

    let recIds = jQuery(evt.item)
      .find('[data-rec-id]')
      .map(function () {
        return jQuery(this).data('rec-id');
      })
      .get();

    let runCallbacksForRecs = false;

    recIds.forEach((rid) => {
      let rec = recsStore.find(rid);
      if (rec.section_id != newSectionId) {
        runCallbacksForRecs = true;
        rec.set({ ...rec, section_id: newSectionId });
      }
    });

    sortOrder.forEach((data) => {
      let s = sectionsStore.find(data.id);
      if (s) {
        s.set({ ...s, sort_order: data.rec_object_ids });
      }
    });

    if (runCallbacksForRecs) {
      // only call when section changed
      recsStore.runCallbacks();
    }

    ComponentEvents.trigger('refresh-broken-owl');
  };

  let checkIntersectsRightSection = function (evt) {
    var selectedSection;
    jQuery('.right-section-name-and-counter').each(function () {
      var elem = jQuery(this);
      var top = elem.offset().top - jQuery(window).scrollTop();
      var left = elem.offset().left - jQuery(window).scrollLeft();
      var height = elem.height() + 4;
      var width = elem.width() + 24;
      var x = evt.originalEvent.clientX;
      var y = evt.originalEvent.clientY;
      if (y >= top && y <= top + height && x >= left && x <= left + width) {
        selectedSection = elem;
        return;
      }
    });
    return selectedSection;
  };

  let moveRecToSection = async function (newSectionId, evt) {
    let recObjectId = jQuery(evt.item).find('[data-rec-object-id]').data('rec-object-id');

    let recIds = jQuery(evt.item)
      .find('[data-rec-id]')
      .map(function () {
        return jQuery(this).data('rec-id');
      })
      .get();

    recIds.forEach((id) => {
      let rec = recsStore.find(id);
      rec.set({ ...rec, section_id: newSectionId });
    });

    let recObjectIds = [];

    jQuery(`div[data-section-id='${newSectionId}']`)
      .find('[data-rec-object-id]')
      .each(function () {
        var recObjectId = jQuery(this).data('rec-object-id');
        recObjectIds.push(recObjectId);
      });

    recsStore.runCallbacks();
    ComponentEvents.trigger('refresh-broken-owl');

    await RecObjectAjax.moveToSection(
      group,
      { id: recObjectId },
      {
        section_id: newSectionId,
        rec_ids: recIds,
        rec_object_ids: recObjectIds,
      }
    );

    let sortOrder = sortOrderWithSectionsFromPage();
    RecObjectAjax.updateSortOrder(group, sortOrder);
  };

  let draggable = function (node) {
    if (isEditable && !mobile) {
      let browserHeight = jQuery(window).height();
      let speedUpPixels = 40;
      let speedUpMultiplier = 3;

      new Sortable(node, {
        group: {
          name: 'recobjects',
        },
        forceFallback: true,
        fallbackOnBody: true,
        fallbackTolerance: 2,
        scroll: true,
        scrollSensitivity: 120,
        scrollSpeed: 20,
        scrollFn: function (x, y, evt, touchEvt, el) {
          if (evt.y <= speedUpPixels || browserHeight - evt.y <= speedUpPixels) {
            y = y * speedUpMultiplier;
          }
          el.scrollTop += y;
        },
        filter: '.undraggable',
        preventOnFilter: false,
        onStart: (evt) => {
          var item = jQuery(evt.item);
          item.children('.draggable-placeholder').show();
          item.find('.ui-rec-object').hide();

          ComponentEvents.trigger('rec-object-dragging', {
            currentSection: section,
            dragging: true,
          });
        },
        onAdd: (evt) => {
          updateSortOrder(evt);
        },
        onUpdate: (evt) => {
          updateSortOrder(evt);
        },
        onEnd: (evt) => {
          let rightIntersectedSection = checkIntersectsRightSection(evt);
          let item = jQuery(evt.item);

          item.find('.ui-rec-object').show();
          item.children('.draggable-placeholder').hide();
          ComponentEvents.trigger('rec-object-dragging', {
            dragging: false,
          });

          if (rightIntersectedSection) {
            let movedSectionId = rightIntersectedSection.closest('[data-right-section-id]').data('right-section-id');

            moveRecToSection(movedSectionId, evt);
          }
        },
      });
    }
  };

  let attachScrollSpy = function (node) {
    if (!node || !section) {
      return;
    }

    ScrollSpy.addElementForKey(
      node,
      'column-current-section',
      {
        section: section,
      },
      section.id
    );
  };

  onDestroy(() => {
    unsubSection && unsubSection();
    unsubRecs();
    unsubGroup();
  });

  CustomScroll.loadRequestedSection($page, 'ui-section-');
</script>

<style style="text/scss" lang="scss">
  :global(.ui-section-middle:last-child) {
    min-height: calc(100vh - (100vh / 2));
  }

  .ui-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    .ui-header {
      margin-top: 60px;
      margin-bottom: 20px;

      .ui-section-name {
        text-align: center;
        font-size: 30px;
        font-weight: 500;
        position: relative;

        .ui-actions {
          z-index: 4;
          opacity: 0;
          visibility: hidden;
          position: absolute;
          padding: 20px;
          border: none;
          background: transparent;
          transition: all 0.25s !important;
          left: 100%;
          margin-top: -27px;

          .remove-btn {
            background: #f3f1f9;
            border-color: #f3f1f9;
            transition: 0.25s;
            width: 52px;
            height: 52px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;

            &:hover {
              background: #ff5567;
              border-color: #ff5567;
              svg {
                fill: white;
              }
            }
          }
        }

        &:hover {
          .ui-actions {
            opacity: 1;
            visibility: visible;
          }
        }
      }

      .ui-section-description {
        margin-top: 32px;
        font-size: 15px;
        line-height: 25px;
        text-align: center;
        color: #7f7f7f;
      }

      .ui-section-items {
        margin-top: 10px;
        display: flex;
        justify-content: center;

        img {
          flex-shrink: 0;
          width: 15px;
          height: 15px;
          min-width: 15px;
          min-height: 15px;
        }

        .ui-items {
          font-size: 13px;
          font-weight: 500;
          padding-left: 10px;
          padding-right: 10px;
        }

        .ui-count {
          opacity: 0.5;
          font-size: 13px;
        }
      }
    }
  }

  .draggable-placeholder {
    border: 2px dashed #ccc;
    background: #eee;
    opacity: 0.5;
    height: 300px;
    width: 100%;
    border-radius: 15px;
    display: none;
    margin-top: 45px;
  }

  .no-section-dragging {
    display: none;
    width: 100%;
    text-align: center;
    border-bottom: 4px solid #eee;
    line-height: 1px;
    margin: 10px 0 20px;
    margin-top: 60px;

    span {
      background: #fff;
      padding: 0 10px;
      font-size: 14px;
      font-weight: 500;
      opacity: 0.75;
    }
  }

  .mobile {
    .ui-section-name {
      margin-left: 30px !important;
      margin-right: 30px !important;
      font-size: 25px !important;
      font-weight: 500 !important;
    }

    .ui-section-items {
      margin-top: 8px !important;
    }

    .search-results-count {
      margin-bottom: 0px !important;
    }

    .ui-section-description {
      font-size: 15px !important;
      line-height: 24px !important;
      margin-top: 24px !important;
    }
  }

  :global(.rec-object-dragging) {
    .no-section-dragging {
      display: block;
    }
  }

  :global(.group-section-h2) {
    font-weight: 500;
    font-size: 25px;
    margin-top: 0px;
    margin-bottom: 0px;
    line-height: 1.3;
    overflow: hidden;
  }
</style>

{#if isEditable}
  {#if showRemoveModal}
    <RemoveSectionModal mobile={mobile} bind:showModal={showRemoveModal} section={section} />
  {/if}

  {#if showSectionsMenu}
    <MobileOptionsModal bind:showModal={showSectionsMenu} options={modalOptions} title="SECTION MENU" />
  {/if}
{/if}

<div class="ui-section ui-section-middle" use:attachScrollSpy class:mobile={mobile}>
  {#if section}
    <div
      style="display: block; position: relative; margin-top:
  -20px;"
      id="ui-section-{section.id}">
      <div class="ui-header">
        <div class="ui-section-name">
          <!-- action bar-->
          {#if isEditable && !mobile}
            <div class="ui-actions undraggable">
              <button class="remove-btn" on:click|preventDefault|stopPropagation={removeSection}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="#ff5567" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 0C10.5523 0 11 0.447715 11 1C11 1.55228 11.4477 2 12
                  2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15
                  4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1
                  2H4C4.55228 2 5 1.55228 5 1C5 0.447715 5.44772 0 6
                  0H10ZM3.21365 15.4616C2.84389 15.1173 2.61761 14.6462 2.58002
                  14.1423L2.02721 6.40427C1.98586 5.82539 2.44433 5.33301
                  3.02467 5.33301H12.9754C13.5557 5.33301 14.0142 5.82539
                  13.9728 6.40426L13.42 14.1423C13.3824 14.6462 13.1561 15.1173
                  12.7864 15.4616C12.4166 15.8059 11.9306 15.9981 11.4254
                  15.9997H4.57468C4.06944 15.9981 3.58341 15.8059 3.21365
                  15.4616Z" />
                </svg>
              </button>
            </div>
          {/if}

          <div style="position: relative; display: inline-block;">
            <Text
              style={mobile && isEditable ? 'width: fit-content;' : 'width: 100%;'}
              text={mobile && !isEditable ? `<h2 class="group-section-h2">${section.name}</h2>` : section.name}
              lines={99}
              editable={isEditable}
              exportTextOnly={true}
              on:blur={(e) => {
                updateSection({ name: e.detail.text });
              }} />

            {#if mobile && isEditable}
              <div
                on:click={() => (showSectionsMenu = true)}
                style="position: absolute; height: 15px; top: -2px; right: -35px;">
                <img src="/images/mobile/section-settings.svg" />
              </div>
            {/if}
          </div>
        </div>

        <div class="ui-section-items">
          <img src="/emojis/purple_star.png" />
          <span class="ui-items">Items</span>
          <span class="ui-count">{recObjectIds.length}</span>
        </div>

        {#if section.description || isEditable}
          <div class="ui-section-description">
            <Text
              style="width: 100% !important;"
              placeholder="Add description"
              lines={2}
              expand={true}
              text={section.description}
              editable={isEditable}
              on:blur={(e) => {
                updateSection({ description: e.detail.text });
              }} />
          </div>
        {/if}
      </div>
    </div>
  {:else if mobile}
    <div style="height: 30px" />
  {/if}

  <div>
    <div use:draggable data-section-id={(section && section.id) || ''}>
      {#each recObjectIds as recObjectId (recObjectId)}
        <div>
          <div class="draggable-placeholder">&nbsp;</div>
          {#if scrollPastRecId && scrollPastRecId === recObjectId}
            <div
              use:inview={{}}
              on:inview_enter={() => {
                if (window.willShowFloatingLikeOrComment != true) {
                  showAddComment = true;
                }
              }}
              on:inview_leave={(event) => {
                const scrollDirection = event.detail.scrollDirection;
                if (scrollDirection && scrollDirection.vertical && window.willShowFloatingLikeOrComment != true) {
                  showAddComment = scrollDirection.vertical == 'up';
                }
              }} />
          {/if}
          <RecObject
            id={recObjectId}
            sectionId={section && section.id}
            columnView={true}
            mobile={mobile}
            on:rec-object-fully-rendered={() => {
              ComponentEvents.trigger('group-rec-object-rendered', recObjectId);
            }} />
        </div>
      {/each}
    </div>
  </div>
</div>
